/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Collection of booking codes supported by the system
 */
export enum EnumBookingCode {
    /**
     * The recipient of this booking is a debtor
     */
    Debtor = 1,
    /**
     * The recipient of this booking is a creditor
     */
    Creditor = 2,
}
